<template>
  <a-modal v-model="visible" :title="`${pageData.name}${$t('消息模板配置')}`" width="80%" :footer="null" destroyOnClose>
    <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <AppMenuPageTemplateEditModal ref="modal" @ok="handleOK" />
  </a-modal>
</template>
<script>
import { getPageTemplateList, removePageTemplate } from '@/api/app/pageTemplate'
import AppMenuPageTemplateEditModal from './AppMenuPageTemplateEditModal.vue'
import { getLabelFromOptions } from '@/utils/dictUtils'

export default {
  components: {
    AppMenuPageTemplateEditModal
  },
  data() {
    return {
      visible: false,
      dataSource: [],
      queryParams: {},
      pageData: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      }
    }
  },
  computed: {
    typeOptions() {
      return [ { label: this.$t('查询'), value: 'select' }, { label: this.$t('新增'), value: 'insert' }, { label: this.$t('更新'), value: 'update' }, { label: this.$t('删除'), value: 'delete' } ]
    },
    columns() {
      return [
        {
          title: this.$t('触发类型'),
          dataIndex: 'type',
          width: '100',
          customRender: (text) => {
            return getLabelFromOptions(text, this.typeOptions, text)
          }
        },
        {
          title: this.$t('触发接口地址'),
          dataIndex: 'apiUrl'
        },
        {
          title: this.$t('模板内容'),
          dataIndex: 'content'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
      ]
    }
  },
  methods: {
    show(data) {
      this.pageData = { ...data }
      this.dataSource = []
      this.queryParams = {}
      this.pagination.current = 1
      this.pagination.total = 0
      this.refresh()
      this.visible = true
    },
    handleAdd() {
      this.$refs.modal.show({ pageId: this.pageData.id })
    },
    handleEdit(record) {
      this.$refs.modal.show(record)
    },
    handleDelete(record) {
      removePageTemplate([record.id]).then(res => {
        if (res.code === 0) {
          this.refresh()
        } else {
          this.$message.error(res.message || this.$t('删除失败'))
        }
      })
    },
    handleOK(data) {
      if (!data.id) {
        this.pagination.current = 1
      }
      this.refresh()
    },
    refresh() {
        this.loadTableData({ pageNum: this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getPageTemplateList({ ...params, pageId: this.pageData.id }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    }
  }
}
</script>